import React, {useState, useEffect} from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Home from './pages/Home';
import Header from './components/Header/Header';
import WrapperApp from './components/Wrapper/WrapperApp';
import ArticleDetail from './pages/ArticleDetail';
import CategoryPage from './pages/CategoryPage';
import TeamPage from './pages/TeamPage';
import TeamMemberDetails from './pages/TeamMemberDetails';
import NotFound from './pages/NotFound';
import TermsConditions from './pages/TermineCondizioni';
import CookiePolicy from './pages/CookiePolicy';
import PrivacyPolicy from './pages/PrivacyPolicy';
import CookieSettings from './pages/CookieSettings';
import ContactUs from './pages/ContactUs';
import ScrollToTopButton from './components/ScrollToTopButton/ScrollToTopButton';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import GlobalLoader from './components/GlobalLoader/GlobalLoader';
import WrapperADS from './components/Wrapper/WrapperADS';
import AdSenseArticle from './components/ADSense/AdSenseArticle/AdSenseArticle';
import PreviewPage from './pages/PreviewPage';

// Istanza di QueryClient per React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1, // Tentativi in caso di errore
      refetchOnWindowFocus: false, // Evita refetch inutili
    },
  },
});


const App = () => {
  const [adsLoaded, setAdsLoaded] = useState(false);

    useEffect(() => {
      const checkAdsLoaded = () => {
        // Verifica se gli annunci sono stati caricati
        const ads = document.querySelectorAll('.adsbygoogle');
        const adsLoaded = Array.from(ads).every(ad => ad.getAttribute('data-adsbygoogle-status') === 'done');
        setAdsLoaded(adsLoaded);
      };
  
      // Aggiungi un listener per verificare quando gli annunci sono caricati
      window.addEventListener('load', checkAdsLoaded);
      return () => window.removeEventListener('load', checkAdsLoaded);
    }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <GlobalLoader>
        <Router>
          <ScrollToTop />
          <ScrollToTopButton />
          <WrapperADS>
            <WrapperApp>
              <Header />
               {adsLoaded && <AdSenseArticle />}
              
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/team" element={<TeamPage />} />
                <Route path="/team/:authorSlug" element={<TeamMemberDetails />} />
                <Route path="/category/*" element={<CategoryPage />} />
                <Route path="/tags/:tagSlug" element={<CategoryPage />} />
                <Route path="/preview/:id" element={<PreviewPage />} />
                <Route path="/:slug" element={<ArticleDetail />} />
                <Route path="/contact-us" element={<ContactUs />} />
                {/* Pagine di policy e condizioni */}
                <Route path="/terms&Conditions" element={<TermsConditions />} />
                <Route path="/cookie-policy" element={<CookiePolicy />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/cookie-settings" element={<CookieSettings />} />
                {/* Pagina di fallback per rotte non trovate */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </WrapperApp>
          </WrapperADS>
        </Router>
      </GlobalLoader>
    </QueryClientProvider>
  );
};

export default App;
